import { createSlice } from '@reduxjs/toolkit'

const initialState = {
}

const featureInfoSlice = createSlice({
  name: 'featureInfo',
  initialState,
})

export const {
  reducer,
} = featureInfoSlice
